import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import MyContext from "../../../MyContext";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";

const POSOrderHistory = ({ userID }) => {
  const { baseUrl, config } = useContext(MyContext);
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState({});
  const [summaryData, setSummaryData] = useState([]);
  const [reciptDetails, setreciptDetails] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [particularOrderDetails, setParticularOrderDetails] = useState(null);

  const [billLoader, setBillLoader] = useState(false);

  const [loading, setLoading] = useState(false);
  const [summaryDate, setSummaryDate] = useState(() =>
    new Date().toISOString().split("T")[0]
  );
  const [fromDate, setFromDate] = useState(() =>
    new Date().toISOString().split("T")[0]
  );
  const [toDate, setToDate] = useState(() =>
    new Date().toISOString().split("T")[0]
  );
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 100;







  const getOrdersApi = async () => {


    setLoading(true);
    setOrders([]);
    setFilteredOrders([]);

    try {
      const payload = {
        userid: userID,
        secret: "string",
        fromdate: fromDate,
        todate: toDate,
        status: ["hold", "completed", "open", "closed"],
      };

      const response = await axios.post(`${baseUrl}/api/Order/v1.0/getPosOrders`, payload, config);

      if (response.data?.responseCode === "00" && response.data?.response?.length > 0) {
        setOrders(response.data.response);
        setFilteredOrders(response.data.response);
      } else {
        Swal.fire({
          icon: "info",
          title: "No Orders Found",
          text: "No orders found for the selected date range.",
          confirmButtonText: "OK",
        });
        setOrders([]);
        setFilteredOrders([]);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      Swal.fire({
        icon: "error",
        title: "Fetch Failed",
        text: "Something went wrong while fetching orders. Please try again later.",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };


  const getSummaryApi = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPosOrdersSummaryData`,
        {
          userid: userID,
          secret: "string",
          fromdate: fromDate,
          todate: toDate,
        },
        config
      );

      const data = response.data;

      if (data.responseCode === "00" && Array.isArray(data.response)) {
        // Set raw orders



        setSummaryData(data);
      } else {
        console.error("API returned failure code or invalid response structure");
        setSummaryData(null);
        setOrders([]);
        setFilteredOrders([]);
      }
    } catch (error) {
      console.error("Error fetching summary data:", error);
      setSummaryData(null);
      setOrders([]);
      setFilteredOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const printReceiptSUMMARY = (
    summaryData,
    reciptDetails,

  ) => {

    const formattedReceiptHTML = `
    <html>
    <head>
      <style>
      body { font-family: Arial, sans-serif;  }
      .container { max-width:600px;  }
       .header {
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;         
  text-align: center;            
  color: #000;
  line-height: 1.1;
  border-bottom: 1px dashed #000;
  margin-top: 10px;
}
.header2 {
  display: flex;
  flex-direction: column; /* Stack sameline divs vertically */
  align-items: flex-start;         
  text-align: start;            
  color: #000;
  line-height: 1.5;
  border-bottom: 1px dashed #000;
  margin-top: 5px;
  padding-bottom: 5px;
  width: 100%; /* Ensure the header2 div spans the full width */
  box-sizing: border-box; /* Include padding and border in element's total width */
}
.sameline {
  display: flex;
  justify-content: center; /* Space items within sameline div */
  width: 100%; /* Ensure sameline items span full width */
  overflow: hidden; /* Prevent content from overflowing */
  white-space: nowrap; /* Prevent text from wrapping */
}



.single-line-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

 .headerTable {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
  align-items: space-between;         
  text-align: start;            
  color: #000;
  line-height: 1.1;
  border-bottom: 1px dashed #000;
  padding:0px;
  margin:0px;
}


  .headerTotal {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
  align-items: flex-start;         
  text-align: start;            
  color: #000;
  line-height: 1.1;
  border-bottom: 1px dashed #000;
  padding-top:5px;
  padding-bottom:5px;
}
.headerEnd {       
  text-align: center;            
  color: #000; 
   padding-bottom: 5px;
}
.textSizeLarge {
font-size: 16px;
margin: 1px; /* Remove margin */
padding: 1px; /* Remove padding */
}
.textSizeMid {
font-size: 10px;
margin: 1px; /* Remove margin */
padding: 1px; /* Remove padding */
}
.textSizeSmall {
font-size: 9px;
margin: 1px; /* Remove margin */
padding: 1px; /* Remove padding */
}
.textWhite{
color:#fff;
}
.receipt-header {
display: flex;
justify-content: space-between;
align-items: flex-start;
margin-top:15px;
}
.single-line-report{
  white-space: nowrap;
}
.left-side {
text-align: left;
}
.right-side {
text-align: right;
}
.business-name{
margin: 0;
padding: 0;
color:#000;
font-size:16px;
}
.address{
margin: 0;
padding: 0;
color:#000;
  font-size:10px;
}
.phone-number{
margin: 0;
padding: 0;
color:#000;
  font-size:10px;
} 
.gst-number {
margin: 0;
padding: 0;
color:#000;
  font-size:10px;
}
.space-between-columns {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aligns the text vertically in the center */
  width: 100%; /* Ensures the flexbox spans the full width of the table header */
}
      .order-details { width: 100%; border-collapse: collapse; }
      .order-details th,
       .order-details td { padding: 5px;font-size: 10px; text-align: left;}
      .order-details2 th, 
      .order-details2 td { 
      
        padding-top:5px;
  padding-bottom:5px;
      font-size: 10px; text-align: left;}
      .total-row { font-weight: bold; }
     .table-text-center {
  text-align: center !important;
}
    </style>
    </head>
    <body>
      <div class="container">
         <div class="header">
<p class="textSizeLarge" style=" font-weight: 600;">${reciptDetails.business_name
      }</p>
<p class="textSizeMid" > ${reciptDetails.address}</p>
<p class="textSizeMid" >PH: ${reciptDetails.phone_no}</p>
<p class="textSizeMid" >GST NO: ${reciptDetails.gst}</p>  
<p class="textSizeLarge" style=" font-weight: 600;">** SUMMARY REPORT **</p>
</div>
<div class="header2">
<div class="sameline">
<div class="textSizeMid single-line-text " >Date :  ${summaryData.fromDate
      }</div>

</div>

</div>

        <div class="headerTable" style="text-align: center;">
          <table class="order-details2">
            <thead>
              <tr>

                <th class="table-text-center single-line-text">ODR.ID</th>
                <th class="table-text-center">MOD</th>

                <th class="table-text-center single-line-report">NAME</th>
                
                <th class="table-text-center single-line-report"> PRICE</th>
              </tr>
            </thead>
          <tbody>
  ${summaryData.response
        .map((item, index) => {
          const orderTypeFormatted =
            item.orderType === "takeway"
              ? "Tkwy"
              : item.orderType === "home_delivery"
                ? "H.Del"
                : item.orderType === "dining"
                  ? "Dine"
                  : item.orderType;

          return `
        <tr>
          
          <td class="table-text-center">${item.daily_order_id}/${item.orderid
            } (${orderTypeFormatted})</td>
           <td class="table-text-center">${item.payment_mode}</td>
            
          <td class="table-text-center">${item.customer_name}</td>
          <td class="table-text-center">${parseFloat(
              item.totalOrderPrice
            ).toFixed(2)}</td>
        </tr>
      `;
        })
        .join("")}
</tbody>
          </table>
        </div>
         
        <div class="headerTotal">
          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 500;">
                            <p class="textSizeMid" style="margin: 0;">Total Cash Collected Amount :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs.  ${summaryData.data2.totalCashCollectedAmount}</p>
                        </div>
          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 500;">
                            <p class="textSizeMid" style="margin: 0;">Total UPI Collected Amount :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs.  ${summaryData.data2.totalUPICollectedAmount}</p>
                        </div>
                                  <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 500;">
                            <p class="textSizeMid" style="margin: 0;">Total Card Collected Amount :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs.  ${summaryData.data2.totalCardCollectedAmount}</p>
                        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 600;">
                            <p class="textSizeMid" style="margin: 0;">Total Order Amount :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs. ${summaryData.totalSummaryAmount
      }</p>
                        </div>

                          
      
      </div>

         <div class="headerTotal">
          

                          
                              
                          
      
      </div>
          <div class="headerEnd">
  <div class="textSizeSmall" style="padding-top: 5px;  margin-top: 10px;">
    <p style="margin: 0;">Order Type Legends:</p>
    <p style="margin: 0;">Tkwy = Takeaway | H.Del = Home Delivery | Dine = Dining</p>
  </div>
  <p class="textSizeMid">** END OF SUMMARY REPORT **</p>
</div>
      </div>
    </body>
    </html>

    `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(formattedReceiptHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  const orderDetailesAPI = async (orderid) => {
    try {
      setBillLoader(true);
      const requestBody = { orderid };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPosOrderDetails`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00" && response.data.response) {
        setParticularOrderDetails(response.data.response);
        setSelectedOrder(response.data.response);
        setShowModal(true); // ✅ Open modal when data fetched
      } else {
        alert("No Order Found");
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    } finally {
      setBillLoader(false);
    }
  };


  const reciptDetailsApi = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/Order/getReceiptData`, {
        userid: userID,
      },config);

      if (response.data.responseCode === "00") {
        const receipt = response.data.response[0];

        setreciptDetails(receipt);


      } else {
        console.error("Failed to fetch organization details");
      }
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  };
  useEffect(() => {
    getOrdersApi();
    getSummaryApi();
    reciptDetailsApi();
  }, []);

  const indexOfLast = currentPage * pageSize;
  const indexOfFirst = indexOfLast - pageSize;
  const currentOrders = filteredOrders.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredOrders.length / pageSize);
const printReceiptSUMMARY_TOTAL = (summaryData, reciptDetails, options = { mode: "full" }) => {
  if (!summaryData || !summaryData.data2) return;

  const mode = options.mode || "full"; // "full" | "collected"

  const { fromDate, toDate, totalSummaryAmount, data2 } = summaryData;

  const {
    totalCashCollectedAmount,
    totalUPICollectedAmount,
    totalCardCollectedAmount,
    totalDeliveryCharges,
    totalPlatformCharges,
    totalMessageCharges,
    homeDeliveryTotal,
    takeawayTotal,
    totalCashCollectedCount,
    totalUPICollectedCount,
    totalCardCollectedCount,
    totalHomeDeliveryCount,
    totalTakeawayCount,
    totalOrdersCount,

    officeOrderTotal,
    carOrderTotal,
    officeOrderCount,
    carOrderCount,
    diningTotal,
    diningCount,
    roomOrderTotal,
    roomOrderCount,
  } = data2;

  const rows = [
    {
      name: "Cash Collected",
      count: totalCashCollectedCount ?? 0,
      amount: totalCashCollectedAmount ?? "0",
    },
    {
      name: "UPI Collected",
      count: totalUPICollectedCount ?? 0,
      amount: totalUPICollectedAmount ?? "0",
    },
    {
      name: "Card Collected",
      count: totalCardCollectedCount ?? 0,
      amount: totalCardCollectedAmount ?? "0",
    },
    {
      name: "Home Delivery",
      count: totalHomeDeliveryCount ?? 0,
      amount: homeDeliveryTotal ?? "0",
    },
    {
      name: "Takeaway",
      count: totalTakeawayCount ?? 0,
      amount: takeawayTotal ?? "0",
    },
    {
      name: "Office Order",
      count: officeOrderCount ?? 0,
      amount: officeOrderTotal ?? "0",
    },
    {
      name: "Car Order",
      count: carOrderCount ?? 0,
      amount: carOrderTotal ?? "0",
    },
    {
      name: "Dining",
      count: diningCount ?? 0,
      amount: diningTotal ?? "0",
    },
    {
      name: "Room Order",
      count: roomOrderCount ?? 0,
      amount: roomOrderTotal ?? "0",
    },
    // 👇 amount-only section (no count)
    {
      name: "Delivery Charges",
      count: "-",
      amount: totalDeliveryCharges ?? "0",
    },
    {
      name: "Platform Charges",
      count: "-",
      amount: totalPlatformCharges ?? "0",
    },
    {
      name: "Message Charges",
      count: "-",
      amount: totalMessageCharges ?? "0",
    },
  ];

  // 🔍 Helper: parse to number safely
  const toNum = (val) => {
    if (val === null || val === undefined || val === "-") return 0;
    const n = typeof val === "string" ? parseFloat(val) : Number(val);
    return isNaN(n) ? 0 : n;
  };

  // 🧠 Apply filtering for "collected" mode
  const filteredRows =
    mode === "collected"
      ? rows.filter((row) => {
          if (row.count === "-") {
            // only keep charges if amount != 0
            return toNum(row.amount) !== 0;
          } else {
            const countNum = toNum(row.count);
            const amtNum = toNum(row.amount);
            return countNum > 0 || amtNum !== 0;
          }
        })
      : rows;

  const tableRowsHtml = (() => {
    let html = "";
    let lineInserted = false;

    filteredRows.forEach((row) => {
      const isAmountOnly = row.count === "-";

      // Insert ONLY ONE separator before first "no count" row
      if (isAmountOnly && !lineInserted) {
        html += `
          <tr>
            <td colspan="3" style="border-top:2px solid #000; padding:0; margin:0;"></td>
          </tr>
        `;
        lineInserted = true;
      }

      html += `
        <tr>
          <td style="padding:4px 6px;">${row.name}</td>
          <td style="padding:4px 6px; text-align:center;">${row.count}</td>
          <td style="padding:4px 6px; text-align:right;">Rs. ${row.amount}</td>
        </tr>
      `;
    });

    return html;
  })();

  const formattedReceiptHTML = `
    <html>
      <head>
        <style>
          @page {
            margin: 0;
          }
          body {
            margin: 6px;
            font-family: Arial, sans-serif;
          }
          .container {
            width: 100%;
            padding: 6px 8px;
          }
          .header {
            text-align: center;
            border-bottom: 1px dashed #000;
            padding-bottom: 6px;
            margin-bottom: 6px;
          }
          .text-lg { font-size: 16px; margin: 2px 0; }
          .text-md { font-size: 12px; margin: 2px 0; }
          .text-sm { font-size: 10px; margin: 1px 0; }

          .section {
            padding: 4px 0;
            border-bottom: 1px dashed #000;
          }

          table.summary-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 4px;
          }
          table.summary-table th,
          table.summary-table td {
            border-bottom: 1px solid #ddd;
            font-size: 12px;
          }
          table.summary-table th {
            text-align: left;
            padding: 4px 6px;
          }

          .footer {
            text-align: center;
            margin-top: 8px;
            font-size: 11px;
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <p class="text-lg" style="font-weight:600;">${reciptDetails.business_name || ""}</p>
            <p class="text-sm">${reciptDetails.address || ""}</p>
            <p class="text-sm">PH: ${reciptDetails.phone_no || ""}</p>
            <p class="text-sm">GST NO: ${reciptDetails.gst || ""}</p>
            <p class="text-lg" style="font-weight:600; margin-top: 4px;">SUMMARY TOTALS (${mode === "collected" ? "COLLECTED ONLY" : "FULL"})</p>
          </div>

          <div class="section">
            <p class="text-md">From: ${fromDate || "-"}</p>
            <p class="text-md">To: ${toDate || fromDate || "-"}</p>
          </div>

          <div class="section">
            <table class="summary-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th style="text-align:center;">Count</th>
                  <th style="text-align:right;">Amount (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                ${tableRowsHtml}
                <tr>
                  <td style="padding:4px 6px; font-weight:600;">Total Orders</td>
                  <td style="padding:4px 6px; text-align:center; font-weight:600;">
                    ${totalOrdersCount ?? "-"}
                  </td>
                  <td style="padding:4px 6px; text-align:right; font-weight:600;">
                    Rs. ${totalSummaryAmount ?? "0"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="footer">
            <p>** END OF SUMMARY TOTALS **</p>
          </div>
        </div>
      </body>
    </html>
  `;

  const printWindow = window.open("", "_blank");
  printWindow.document.write(formattedReceiptHTML);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};






  return (
    <div className="p-4 light" style={{ fontFamily: "Nunito, sans-serif" }}>
      <div className="bg-white px-4" style={{ borderRadius: "10px" }}>
        <div className="d-flex justify-content-between align-items-center border-15-only px-2  py-1">
          <div className="CreateCampaign">POS Orders History</div>




        </div>

        {/* Filters */}
        <Form className="mb-3">
          <Row className="align-items-start">
            <Col md={2}>
              <Form.Group controlId="fromDate">
                {/* <Form.Label>From Date</Form.Label> */}
                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group controlId="toDate">
                {/* <Form.Label>To Date</Form.Label> */}
                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={1}>
              <Button
                onClick={() => getOrdersApi()}
                className="w-100 bg-green-order border border-white"
              >
                {loading ? (
                  < >

                    Loading...
                  </>
                ) : (
                  "Search"
                )}
              </Button>
            </Col>
            <Col md={2}>
              <button
                className="blue-button w-100"
                onClick={(e) => {
                  e.preventDefault();
                  if (!summaryData) {

                    Swal.fire({
                      icon: "info",
                      title: "No Data Found",
                      text: "No data found for the selected dates. Please try again with different dates.",
                      confirmButtonText: "OK",
                    });
                  } else {
                    printReceiptSUMMARY(
                      summaryData,
                      reciptDetails,
                    );
                  }
                }}
              >
                Summary Report
              </button>

            </Col>
 <Col md={2}>
  <button
    className="blue-button w-100"
    onClick={(e) => {
      e.preventDefault();
      if (!summaryData || !summaryData.data2) {
        Swal.fire({
          icon: "info",
          title: "No Summary Data",
          text: "No summary totals available for the selected dates.",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "What do you want to print?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Full Summary",
          cancelButtonText: "Collected Only",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            // Full summary: print all rows
            printReceiptSUMMARY_TOTAL(summaryData, reciptDetails, { mode: "full" });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            // Collected summary: only non-zero rows
            printReceiptSUMMARY_TOTAL(summaryData, reciptDetails, { mode: "collected" });
          }
        });
      }
    }}
  >
    Summary Totals
  </button>
</Col>


          </Row>
        </Form>

        {/* {JSON.stringify(summaryData)}m */}
        {/* Table */}
        <div className="table-responsive rounded-4 shadow-sm border border-secondary-subtle">
          <table
            className="table align-middle text-center mb-0"
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "0.95rem",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            <thead
              className="text-uppercase text-white"
              style={{
                background: "linear-gradient(90deg, #212529 0%, #343a40 100%)",
                fontWeight: "600",
                letterSpacing: "0.03em",
              }}
            >
              <tr>
                <th className="py-3">ODR ID</th>
                <th className="py-3">BILL NO.</th>
                <th className="py-3">DATE</th>
                <th className="py-3">CUSTOMER</th>
                <th className="py-3">MOB</th>
                <th className="py-3">ODR TYPE</th>
                <th className="py-3">ODR AMT</th>
                <th className="py-3">DISCOUNT</th>
                <th className="py-3">CGST</th>
                <th className="py-3">SGST</th>
                <th className="py-3">NET AMT</th>
                <th className="py-3">MODE</th>
                <th className="py-3">DETAILS</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="13" className="text-center py-5 text-muted fs-5">
                    <div className="spinner-border text-secondary me-2" role="status" />
                    Fetching orders...
                  </td>
                </tr>
              ) : currentOrders.length > 0 ? (
                [...currentOrders].reverse().map((order) => (
                  <tr
                    key={order.id}
                    className={`cursor-pointer ${selectedOrder?.orderid === order.orderid
                        ? "table-success shadow-sm"
                        : ""
                      }`}
                    style={{
                      transition: "all 0.2s ease",
                      borderBottom: "1px solid #dee2e6",
                    }}
                    onClick={() => setSelectedOrder(order)}
                  >
                    <td className="fw-semibold">{order.daily_order_id || "HOLD"}</td>
                    <td className="text-dark fw-semibold">{order.orderid}</td>
                    <td className="text-secondary">{order.order_date}</td>
                    <td>{order.customer_name || "N/A"}</td>
                    <td>{order.customer_mobile || "N/A"}</td>
                    <td>
                      <span
                        className={`badge ${order.orderType === "homedelivery"
                            ? "bg-primary"
                            : order.orderType === "takeaway"
                              ? "bg-info"
                              : "bg-success"
                          } bg-opacity-75 px-3 py-2 text-uppercase`}
                      >
                        {order.orderType}
                        {order.orderType === "dining" && ` | T${order.table_no}`}
                      </span>
                    </td>
                    <td className="fw-bold text-dark">₹ {order.subtotal}</td>
                    <td className=" ">₹ {order.discount_amount}</td>
                    <td className="">₹ {Number(order.tax_cgst).toFixed(2)}</td>
                    <td className="">₹ {Number(order.tax_sgst).toFixed(2)}</td>
                    <td className="fw-bold text-dark fs-6">
                      ₹ {order.totalOrderPrice}
                    </td>
                    <td>
                      <span
                        className="badge bg-dark bg-opacity-75 text-white px-3 py-2 text-uppercase"
                        style={{ fontSize: "0.8rem" }}
                      >
                        {order.payment_mode || "N/A"}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-outline-dark btn-sm fw-bold rounded-pill px-4 py-2"
                        style={{
                          transition: "all 0.2s",
                          fontSize: "0.85rem",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        }}
                        onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#212529",
                          e.target.style.color = "#fff")
                        }
                        onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "transparent",
                          e.target.style.color = "#000")
                        }
                        onClick={() => orderDetailesAPI(order.orderid)}
                        disabled={billLoader}
                      >
                        {billLoader ? "Loading..." : "View"}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" className="text-center text-muted py-5 fs-5">
                    No orders found for selected filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>



        {/* Pagination */}
        {filteredOrders.length > pageSize && (
          <div className="d-flex justify-content-center mt-3">
            <nav>
              <ul className="pagination">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (page) => (
                    <li
                      key={page}
                      className={`page-item ${currentPage === page ? "active" : ""
                        }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    </li>
                  )
                )}
              </ul>
            </nav>
          </div>
        )}
      </div>
      {showModal &&
        ((selectedOrder && Object.keys(selectedOrder).length > 0) ||
          (particularOrderDetails &&
            Object.keys(particularOrderDetails).length > 0)) && (
          <>
            {/* Overlay */}
            <div
              className="position-fixed top-0 start-0 w-100 h-100"
              style={{ backgroundColor: "#00000088", zIndex: 1040 }}
              onClick={() => setShowModal(false)}
            />

            {/* Modal */}
            <div
              className="position-fixed top-50 start-50 translate-middle bg-white border shadow-lg p-5 rounded-4 fs-5"
              style={{
                width: "1000px",
                zIndex: 1050,
                fontFamily: "monospace",
                position: "relative",
              }}
            >
              {/* ✅ Copied Close Button (same UI as original bottom CLOSE button) */}
              <button
                type="button"
                onClick={() => {
                  setShowModal(false);
                  setParticularOrderDetails({});
                  setSelectedOrder({});
                }}
                style={{
                  height: "60px",
                  width: "150px",
                  position: "absolute",
                  top: "20px",
                  right: "20px",
                }}
                className="scale-button shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-5 fw-bold"

              >
                CLOSE
              </button>

              {/* Modal Main Content */}
              <div className="col-12">
                <div className="p-4 rounded">
                  <div className="text-center mb-4">
                    <h2 className="fw-bold">Order Details #{selectedOrder.orderid}</h2>
                    <p>{selectedOrder.order_date}</p>
                    <hr />
                  </div>

                  {/* Delivery Section */}
                  {selectedOrder.orderType === "homedelivery" && (
                    <div className="card border-0 shadow-sm mb-3 w-100">
                      <div className="card-header bg-warning text-dark fw-semibold py-2 px-3">
                        Delivery Status:{" "}
                        <span className="text-uppercase">
                          {selectedOrder.delivery_partner_status || "N/A"}
                        </span>
                      </div>
                      <div className="card-body bg-warning bg-opacity-10 py-2 px-3">
                        <div>
                          <span className="fw-bold">Delivery Person:</span>{" "}
                          <span className="text-dark">
                            {selectedOrder.delivery_person_name || "N/A"} |{" "}
                            {selectedOrder.delivery_person_number || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Customer Info */}
                  <div className="mb-3">
                    <strong>Customer:</strong> {selectedOrder.customer_name}
                    <br />
                    <strong>Phone:</strong> {selectedOrder.customer_mobile}
                    {selectedOrder.billingName && (
                      <>
                        <br />
                        <strong>Billing Name:</strong> {selectedOrder.billingName}
                      </>
                    )}
                    {selectedOrder.billingGst && (
                      <>
                        <br />
                        <strong>Billing GST:</strong> {selectedOrder.billingGst}
                      </>
                    )}
                    {selectedOrder.billingAddress && (
                      <>
                        <br />
                        <strong>Billing Address:</strong> {selectedOrder.billingAddress}
                      </>
                    )}
                  </div>

                  {/* Items Table */}
                  <div className="table-responsive mb-5">
                    <table className="table table-bordered text-center align-middle shadow-sm">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Item Name</th>
                          <th>Qty</th>
                          <th>Unit Price (₹)</th>
                          <th>Total (₹)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedOrder.items?.map((item, index) => {
                          const price = parseFloat(item.item_price || "0");
                          const quantity = parseInt(item.quantity || "1", 10);
                          const total = price * quantity;

                          let customizationText = "";
                          try {
                            const parsed = JSON.parse(item.customization || "[]");
                            customizationText = parsed
                              .flatMap((c) =>
                                Array.isArray(c.options) ? c.options : [c.options]
                              )
                              .join(", ");
                          } catch { }

                          return (
                            <tr key={item.id}>
                              <td>{index + 1}</td>
                              <td className="text-start">
                                {item.item_name}
                                {item.sizeWords ? ` (${item.sizeWords})` : ""}
                                {customizationText && (
                                  <div
                                    className="text-muted"
                                    style={{
                                      fontSize: "0.85rem",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {customizationText}
                                  </div>
                                )}
                              </td>
                              <td>{quantity}</td>
                              <td>₹{price.toFixed(2)}</td>
                              <td>₹{total.toFixed(2)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Price Summary */}
                  <div className="d-flex justify-content-between">
                    <span>Subtotal:</span>
                    <span>₹ {parseFloat(selectedOrder.subtotal).toFixed(2)}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <>Hello</>
                    <span>Discount Amount:</span>
                    <span>₹ {parseFloat(selectedOrder.discount_amount).toFixed(2)}</span>
                  </div>


                  <>
                    <div className="d-flex justify-content-between">
                      <span>CGST:</span>
                      <span>₹{parseFloat(selectedOrder.tax_cgst).toFixed(2)}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>SGST:</span>
                      <span>₹{parseFloat(selectedOrder.tax_sgst).toFixed(2)}</span>
                    </div>
                  </>


                  <div className="d-flex justify-content-between">
                    <span>Other Charges:</span>
                    <span>₹ {parseFloat(selectedOrder.charges || 0).toFixed(2)}</span>
                  </div>
                  <hr />
                  <div className="d-flex justify-content-between fw-bold fs-5">
                    <span>Total:</span>
                    <span>₹ {parseFloat(selectedOrder.totalOrderPrice).toFixed(2)}</span>
                  </div>

                  <div className="text-end mt-4 fs-4">
                    <div className="text-dark fw-bold">
                      Payment Status:{" "}
                      {selectedOrder.payment_status?.toUpperCase() || "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

    </div>
  );
};

export default POSOrderHistory;
